import { getInitData } from '@barev/web';

/**
 * Внутри Telegram запросы подписаны initData. В браузере (кабинет менеджера партнёра на компьютере)
 * — токен: бот выдаёт одноразовую ссылку ?login=<код>, страница меняет её на токен и хранит в localStorage.
 */
const initData = getInitData();
const TOKEN_KEY = 'barev.pro.web';

function readToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}
let webToken = initData ? null : readToken();

export const hasAuth = () => !!initData || !!webToken;
export const isWeb = () => !initData;
export const authHeader = (): Record<string, string> => (initData ? { authorization: `tma ${initData}` } : webToken ? { authorization: `pro ${webToken}` } : {});

export function forgetWebLogin() {
  webToken = null;
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* приватный режим */
  }
}

/** Ссылка из бота: обменять одноразовый код на токен до первого запроса */
export async function consumeLoginLink(): Promise<void> {
  if (initData) return;
  const url = new URL(window.location.href);
  const code = url.searchParams.get('login');
  if (!code) return;
  url.searchParams.delete('login');
  window.history.replaceState(null, '', url.toString());
  try {
    const res = await fetch('/trpc/pro.webLogin', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ json: { code } }) });
    const body = (await res.json()) as { result?: { data?: { json?: { token: string } } } };
    const token = body.result?.data?.json?.token;
    if (!token) return;
    webToken = token;
    try {
      localStorage.setItem(TOKEN_KEY, token);
    } catch {
      /* без localStorage вход действует до закрытия вкладки */
    }
  } catch {
    /* сеть — покажем экран «откройте ссылку из бота» */
  }
}
